import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

export class Conditional extends React.Component {
  render() {
    if (!this.props.show || React.Children.count(this.props.children) === 0) {
      return null;
    }
    return <Fragment>{this.props.children}</Fragment>;
  }
}

Conditional.defaultProps = {
  show: false
};

Conditional.propTypes = {
  show: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired
};



// WEBPACK FOOTER //
// ./src/components/Conditional.js